import { render } from "./DeleteSection.vue?vue&type=template&id=748a6e6c"
import script from "./DeleteSection.vue?vue&type=script&lang=js"
export * from "./DeleteSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__